export function footerFunc() {
  const footer = document.querySelector('.site-footer-content');
  const homeUrl = document.querySelector('body').dataset.homeUrl;

  const footerContact = document.createElement('div');
  footerContact.classList.add('footer-contact');
  footerContact.innerHTML = `
    <a href="${homeUrl}contact" class="footer-contact__link">
      <span class="footer-contact__link-head">CONTACT</span>
      <span class="footer-contact__link-text">お問い合わせはこちら</span>
    </a>
    <a href="${homeUrl}" class="footer-contact__logo"></a>
  `;
  footer.prepend(footerContact);
}
